import { render } from "./MiniSearch.vue?vue&type=template&id=54ce458d&scoped=true"
import script from "./MiniSearch.vue?vue&type=script&lang=js"
export * from "./MiniSearch.vue?vue&type=script&lang=js"

import "./MiniSearch.vue?vue&type=style&index=0&id=54ce458d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ce458d"]])

export default __exports__